import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { goodsViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewGrn from "../../../components/purchase-section/goods-receipt/create-edit-view-grn";

const EditGoodsReceipt = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(goodsViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  console.log(orderDetail, "dsfsfsdfsdfsfsdfsdfs");

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");

  return (
    <InnerLayout backBtn={true} title="Goods Receipt Edit">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewGrn
          // <GoodsRecComp
          clickedplus={isNew}
          payto={orderDetail?.orderData?.gort_pay_to_address}
          shipto={orderDetail?.orderData?.gort_ship_to_address}
          pageType="grn"
          page="edit"
          disabled={
            true && orderDetail?.orderData?.gort_order_status !== "draft"
          }
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default EditGoodsReceipt;
